import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { CenteredLoader } from '@/components/utils/Loader';
import { SubscriptionDetail } from '@/types/subscriptions/subscription';
import { DetailContents } from './DetailContents';

export type Props = {
  isDataFetched: boolean;
  subscription: SubscriptionDetail;
  cancelSubscription: () => Promise<void>;
};

export const Detail: React.FC<Props> = ({
  isDataFetched,
  subscription,
  cancelSubscription,
}) => {
  const { t } = useTranslation();
  const title = t('pages.subscription.detail.title');

  if (!isDataFetched) {
    return <CenteredLoader />;
  }

  return (
    <PageRootWrapper
      title={title}
      breadcrumbItems={[{ label: title }]}
      containerType="normal"
    >
      <DetailContents
        title={title}
        subscription={subscription}
        cancelSubscription={cancelSubscription}
      />
    </PageRootWrapper>
  );
};
